import styled from 'styled-components';

// Primitiv-Bibliothek (2026-06): zentrales Initialen-Avatar-Primitiv.
// Konsolidiert 4 duplizierte ...Letters-Spans (VacancyLogoLetters,
// ApplicationLogoLetters, AvatarLetters in Message + UserAvatarUploader) zu EINEM
// Primitiv. Kapselt NUR die Initialen-Span (Farbe + Form + Zentrierung) — NICHT den
// umgebenden Bild-Container (gehoert zur spaeteren Avatar-Welle). Token-Aufloesung
// mit Fallback-Kette analog Card/CardStyled.js (greift nur ohne vollstaendigen
// ThemeProvider).

// bg: 'secondaryLight' -> navy-blau (Vacancy/Application/UserAvatarUploader + nicht-
// eigene Nachrichten); 'warning' -> orange (eigene Chat-Nachricht); jeder andere
// String wird als roher CSS-Farbwert durchgereicht (Escape-Hatch).
const resolveBg = ({ theme, bg }) => {
  switch (bg) {
    case 'secondaryLight':
      return theme.secondaryLight;
    case 'warning':
      return theme.warningColor;
    default:
      return bg;
  }
};

// absolute: deckt die innerhalb eines positionierten Bild-Containers liegenden
// Avatare ab (Message/UserAvatarUploader) — Span fuellt den Container per
// top/right/bottom/left:0. Ohne absolute (Vacancy/Application) traegt der Container
// selbst kein position -> Span fuellt ihn per width/height:100%.
const resolveFill = ({ absolute }) => (absolute
  ? `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `
  : `
    width: 100%;
    height: 100%;
  `);

// font-style: normal MUSS explizit gesetzt sein — der Chat-Konsument (Message) liegt
// unter MessagesWrapper (font-style: italic, MessagesStyled.js), das sonst bis in die
// Initialen durchschlaegt (kursive Avatare). Das Alt-AvatarLetters trug normal; fuer
// die 3 nicht-Chat-Konsumenten ist normal der Default -> render-neutral.
export const LetterAvatarSpan = styled.span`
  color: ${({ theme }) => theme.white};
  background-color: ${resolveBg};
  font-size: ${({ fontSize }) => fontSize}px;
  text-transform: uppercase;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontWeightUpperBold || 600};
  border-radius: ${({ theme }) => theme.borderRadiusRound || '50%'};
  display: flex;
  align-items: center;
  justify-content: center;
  ${resolveFill};
`;
